import { createTheme } from '@mui/material/styles';
import { grey, lightGreen, red, orange } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      light: grey[500],
      main: grey[800],
      dark: grey[900],
      contrastText: grey[100],
    },
    secondary: {
      light: lightGreen[500],
      main: lightGreen[800],
      dark: lightGreen[900],
      contrastText: grey[900],
    },
    info: {
      light: grey[100],
      main: grey[200],
      dark: grey[500],
      contrastText: grey[700],
    },
    warning: {
      light: orange[100],
      main: orange[400],
      dark: orange[600],
      contrastText: grey[900],
    },
    background: {
      default: grey[200],
    },
    text: {
      primary: grey[900],
    },
  },
  status: {
    danger: red[500],
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
              backgroundColor: grey[100],
          },
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '&': {
              backgroundColor: grey[100],
          },
        }
      }
    },
  },
});

export default theme;